import lod_ from "lodash";
import MDBox from "components/Basics/MDBox";
import { t } from "i18next";
import DragAndDrop from "pages/sources/components/DragAndDrop";
import { useEffect, useState } from "react";
import { checkIfSourcesExist } from "hooks/sources";
import { useDispatch } from "react-redux";
import MDTypography from "components/Basics/MDTypography";
import { CircularProgress } from "@mui/material";

/**
 * Import local files
 * @param {*} param0
 * @returns {JSX.Element} StepImport
 */
export default function StepImport({ skeleton, validStep, handleSave, handleNext }) {
	const dispatch = useDispatch();
	const [loading, setLoading] = useState(false);

	// Save files
	const onFilesSelection = async (localFiles, files) => {
		handleSave({
			localFiles,
			files
		});
		handleNext();
	};

	const loadFiles = async files => {
		setLoading(true);

		if (lod_.isEmpty(skeleton.files)) {
			const mappedFiles = files.map(file => {
				return {
					name: file.name,
					url: file.name // For local files, the url is the file name
				};
			});

			const filesResult = await checkIfSourcesExist(dispatch, mappedFiles);

			setLoading(false);
			validStep();
			onFilesSelection(files, filesResult);
		} else {
			setLoading(false);
			validStep();
		}
	};

	useEffect(() => {
		setLoading(false);
	}, []);

	return (
		<MDBox flex="1" display="flex" flexDirection="row" style={{ height: "100%", width: "100%" }}>
			<MDBox ml={1} flex="3" style={{ height: "100%", width: "100%" }}>
				{loading && (
					<MDBox
						sx={{
							display: "flex",
							flexDirection: "column",
							alignItems: "center",
							justifyContent: "center",
							height: "100%"
						}}
					>
						<MDTypography variant="h4">{t("SOURCES.FILES.loadingFiles")}</MDTypography>
						<MDTypography variant="subtitle2">{t("SOURCES.FILES.waitWhileLoading")}</MDTypography>
						<MDBox display="flex" justifyContent="center" mt={15}>
							<CircularProgress color="info" size={50} />
						</MDBox>
					</MDBox>
				)}
				{!loading && (
					<DragAndDrop
						handleFiles={files => {
							loadFiles(Array.from(files));
						}}
					/>
				)}
			</MDBox>
		</MDBox>
	);
}
